'use client';

import { ListingPromoBanner } from '@/features/products/components/list/banners/listingPromoBanner/listingPromoBanner';
import { ProductListRowItem } from '@/features/products/components/list/productListSection/types';
import { ListingProductCard } from '@/features/products/components/listingProductCard/listingProductCard';
import { ListingProductCardTaxonData } from '@/features/products/components/listingProductCard/types';
import { ProductListingItem } from '@/features/products/types/product';

interface ProductListItem {
  index: number;
  item: ProductListRowItem;
  taxonData?: ListingProductCardTaxonData;
  authToken?: string;
}

function isProductItem(item: ProductListRowItem): item is ProductListingItem {
  return typeof item === 'object' && item !== null && 'slug' in item;
}

const ProductListItem = ({ index, item, authToken, taxonData }: ProductListItem) => {
  if (isProductItem(item)) {
    return (
      <div className="w-full flex justify-center">
        <ListingProductCard
          key={item.code}
          {...item}
          priority={index < 6}
          taxonData={taxonData}
          authToken={authToken}
        />
      </div>
    );
  }

  return (
    <div className="w-full flex justify-center h-full">
      <ListingPromoBanner banner={item} />
    </div>
  );
};

export default ProductListItem;
